import { useTranslation } from "react-i18next";

import { IconFileShield02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

export const GpfHistoryPageHeader = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconFileShield02 size="20" />,
    },
    {
      label: t("GPF_HISTORY.BREADCRUMBS.FIRST_STEP"),
    },
  ];

  const headerText = {
    header: t("GPF_HISTORY.HEADING"),
    subHeader: t("GPF_HISTORY.DESCRIPTION"),
  };

  return <Header breadcrumbs={breadcrumbs} headerText={headerText} />;
};
